import { API_URL } from '../../helpers/constants';
import request from '../../utils/request';
import { CompaniesData, GetCompaniesDataPayload } from './types';

export const getCompaniesData = async (
  payload: GetCompaniesDataPayload,
  signal?: AbortSignal,
) => {
  const parameters: URLSearchParams = new URLSearchParams({
    originId: payload.originId.toString(),
    destinationId: payload.destinationId.toString(),
    transportType: payload.transportType,
  });

  const calendar: CompaniesData = await request(
    `${API_URL}/data/companies?${parameters}`,
    { signal },
  );

  return calendar;
};
